<template>
  <div>
    <div class="col-12 col-md-5 mt-3">
      <div class="button-gradient-yellow">
        <label>Valor total a arriscar:</label>
      </div>
      <money 
        v-model="totalValue" 
        v-bind="money"
        :keyup="verifyTotalValue()"
        class="form-control input-format-grey"
        style="padding-left: 240px;" 
      />
    </div>

    <div class="col-md-12 mb-4"></div>

    <div class="list-dutching row">

      <div class="row" v-for="(input, k) in inputs" :key="k">
        <div class="col-12 col-md-1 mt-3" style="padding-top: 5px;">
          <label style="font-weight: 700; font-size: 20px"><b>{{k + 1}}.</b></label>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <div class="button-gradient-yellow" style="width: 160px;">
            <label>Odd Back:</label>
          </div>
          <money 
            v-model="input.oddBack"
            v-bind="odd"
            :keyup="verifyOddBack(input.oddBack)"
            class="form-control input-format-grey"
            style="padding-left: 170px;" 
          />
        </div>
        <div class="col-12 col-md-4 mt-3">
          <div class="button-gradient-green" style="width: 140px;">
            <label class="text-white">Aposta:</label>
          </div>
          <money v-model="input.betValue" class="form-control input-format-green" v-bind="money" style="padding-left: 150px;" disabled />
        </div>
        
        <div style="text-align: left; padding-left: 120px;">
          <button class="icon-add-remove add" @click="add(k)" v-show="k == inputs.length-1">
            <b>+</b>
          </button>
          <button class="icon-add-remove remove"
          @click="remove(k)" v-show="k == inputs.length-1 && k > 0">
            -
          </button>
        </div>

      </div>

      <!--<div class="form-check mt-4" style="text-align: left; margin-left: 100px;">
        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
        <label class="form-check-label" for="flexCheckDefault">
          Todas as apostas no mesmo mercado
        </label>
      </div>-->

      <div class="col-12 col-md-3 mt-5">
        <div class="button-gradient-yellow" style="width: 150px;">
          <label>Comissão:</label>
        </div>
        <money 
          v-model="comission"
          v-bind="percent"
          class="form-control input-format-grey disable"
          disabled
          style="padding-left: 160px;" 
        />
      </div>
      <div class="col-12 col-md-5 mt-5" style="margin-left: 20px;">
        <div class="button-gradient-green">
          <label class="text-white">Lucro / Prejuizo:</label>
        </div>
        <money 
          v-model="cashoutTotal" 
          v-bind="money"
          class="form-control input-format-grey"
          style="padding-left: 210px;" 
          disabled
        />
      </div>
      
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'MultiBack',
  components: {
    Money
  },
  data () {
    return {
      totalValue: 100,
      comission: '6.50',
      inputs: [
        {
          oddBack: 2,
          betValue: ''
        },
      ],
      cashoutTotal: 0,
      odd: {
        decimal: '.',
        prefix: '@',
        suffix: '',
        precision: 2,
        masked: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      percent: {
        decimal: '.',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    add() {
      this.inputs.push({oddBack: 2, betValue: ''})
    },
    remove(index) {
      this.inputs.splice(index, 1);
    },
    verifyTotalValue() {

      let probTotal = this.inputs.reduce((acc, cur) => {
        let probability = this.totalValue / cur.oddBack;
        acc += probability;
        return acc;
      }, 0);

      let betValue = this.inputs.reduce((acc, cur) => {
        let valueBetValue = cur.betValue;
        acc += valueBetValue;
        return acc;
      }, 0);

      if (probTotal == 0) {
        return;
      }

      for (let key in this.inputs) {
        for (let index = 0; index < this.inputs.length; index++) {
          this.inputs[key].betValue = ((this.totalValue / this.inputs[key].oddBack)/probTotal) * this.totalValue;
        }
        this.cashoutTotal = ((this.inputs[0].oddBack - 1) * this.inputs[0].betValue) - (betValue - this.inputs[0].betValue)
      }
      
    },
    verifyOddBack(i) {
      return i
    }
  }
}
</script>

<style scoped>
.input-format-grey {
  padding-left: 200px;
}
.input-format-green {
  padding-left: 190px;
}
.icon-add-remove {
  border: 1px solid #333B42;
  border-radius: 5px;
  opacity: 1;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-top: 20px;
}
.icon-add-remove {
  border: 1px solid #333B42;
  border-radius: 5px;
  opacity: 1;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-top: 20px;
  background: #FFF;
  transition: 0.2s linear;
}
.add:hover {
  background: var(--unnamed-color-ffb01f);
  color: white;
  border-color: white;
}
.remove:hover {
  background: #333B42;
  color: white;
  border-color: #333B42;
}
</style>
